var React = require('react');

function ResetInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"reset.inline"),React.createElement("g",{"id":"f0451cc1-f0da-4b99-9e8a-af311b97c422","data-name":"Layer 2","key":1},React.createElement("g",{"id":"a6cd1fc5-62d5-4d9c-8b61-65113f0bbe00","data-name":"Layer 1"},React.createElement("path",{"id":"f8a17fd5-8211-4f43-8c25-80f0665b4928","data-name":"reset.inline","d":"M5.32,18.53C3.2,10.62,8.54,2.91,15.94,1.18a13.76,13.76,0,0,1,13.48,4.3m3.47,6.74c1.34,7.15-3.8,14.16-10.66,15.77A13.76,13.76,0,0,1,9.39,24.36m28-5.44-4.5-6.73-5.2,6.21M.81,11.88l4.5,6.74,5.21-6.21","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"})))]);
}

ResetInline.defaultProps = {"viewBox":"0 0 38.17 29.17"};

module.exports = ResetInline;

ResetInline.default = ResetInline;
